// import DbtDocsCodeblock from "./DbtDocsCodeblock";
import ConversationsHighlighter from "./ConversationsHighlighter";
import DbtDocsConversationsRightPanel from "./DbtDocsConversationsRightPanel";
import useConversations from "./conversations/useConversations";
import useConversationUsers from "./useConversationUsers";

const DbtDocsCollaborationComponents = () => {
  useConversationUsers();
  useConversations();

  return (
    <div>
      <DbtDocsConversationsRightPanel />
      <ConversationsHighlighter />
    </div>
  );
};

export default DbtDocsCollaborationComponents;
